import { render, staticRenderFns } from "./sales_area.vue?vue&type=template&id=567fe21a"
import script from "./sales_area.vue?vue&type=script&lang=js"
export * from "./sales_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567fe21a')) {
      api.createRecord('567fe21a', component.options)
    } else {
      api.reload('567fe21a', component.options)
    }
    module.hot.accept("./sales_area.vue?vue&type=template&id=567fe21a", function () {
      api.rerender('567fe21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/target_two/form/sales_area/sales_area.vue"
export default component.exports